import React from "react";
import { MinimalCase } from "../../../types/Entities/MinimalCase";
import { Conversation } from "../../../types/Entities/Messaging/Conversation";
import { getProductData } from "../../../services/productService";
import { useNavigate } from "react-router";
import { getNewMessageLink } from "../../../services/messagingService";
import { TiptapEditorProvider } from "../../Tiptap/TiptapEditorProvider";
import { useCurrentEditor, useEditorState } from "@tiptap/react";
import { FormProvider } from "../../../provider/Form/FormProvider";
import { MessageCenterMessageReplyForm } from "./MessageCenterMessageReplyForm";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type MessageCenterMessageReplyProps = {
  product: MinimalCase;
  conversation: Conversation;
};

export default function MessageCenterMessageReply(props: MessageCenterMessageReplyProps) {
  return (
    <TiptapEditorProvider>
      <MessageCenterMessageReplyInner {...props} />
    </TiptapEditorProvider>
  );
}

function MessageCenterMessageReplyInner({ product, conversation }: MessageCenterMessageReplyProps) {
  const navigate = useNavigate();
  const { editor } = useCurrentEditor();
  const extendedMinimalCase = {
    ...product,
    "@id": getProductData(product.name, "apiUri") + "/" + product.id,
    isCustomerDataCompleted: true,
  };

  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => {
      if (!editor) {
        return null;
      }

      return {
        json: editor.getJSON(),
      };
    },
  });

  if (conversation.isClosed || !conversation.id) {
    return null;
  }

  const onSubmit = () => {
    navigate(getNewMessageLink(extendedMinimalCase.name, extendedMinimalCase.id, conversation.id), {
      state: {
        editor: editorState?.json,
      },
    });
  };

  const initialValues = {
    message: "",
  };

  return (
    <FormProvider initialValues={initialValues} submitAction={onSubmit}>
      <ProductBox headline={"Antwort verfassen"}>
        <MessageCenterMessageReplyForm />
      </ProductBox>
    </FormProvider>
  );
}
